var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "form-phone-verified-phone" },
        [
          _c("el-input", {
            ref: "phoneRef",
            staticClass: "form-phone-verified-phone-input",
            attrs: { placeholder: "输入手机号" },
            on: { change: _vm.onPhoneChange },
            model: {
              value: _vm.phone,
              callback: function($$v) {
                _vm.phone = $$v
              },
              expression: "phone"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "form-phone-verified-phone-button",
              attrs: { disabled: _vm.countDown > 0 },
              on: { click: _vm.sendCode }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.countDown > 0 ? _vm.countDown + "秒后重试" : "发送验证码"
                )
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-input", {
        ref: "code",
        staticClass: "form-phone-verified-code",
        attrs: { placeholder: "输入短信验证码" },
        on: { change: _vm.onCodeChange },
        model: {
          value: _vm.code,
          callback: function($$v) {
            _vm.code = $$v
          },
          expression: "code"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64cb74b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64cb74b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketFormPhoneVerified.vue
// module id = 1010
// module chunks = 75